import { useDispatch, useSelector } from '~Hooks';
import { BongPrint, generateID } from '~reducers';
import * as actions from '~actions';

/**
 * Hook that exposes a function to save to Bong History
 * The history will then be visible in the PrinterStatus component
 *
 * @param groupId - The ID of the BongGroup
 * @param orderInfoTitle - The order title (e.g #111 or Table 5)
 */
export const useBongHistory = (groupId: string, orderInfoTitle: string) => {
  const dispatch = useDispatch();
  const staff = useSelector((state) => state.staff);

  /** Saves information about a printed bong to the history */
  const savePrintAttempt = ({ printerId = '', reason = '', hasBeenAttempted = true }) => {
    const print: BongPrint = {
      id: generateID(),
      printerId,
      hasBeenAttempted,
      reason,
    };

    dispatch({
      type: actions.SAVE_BONG_PRINT,
      groupId,
      title: orderInfoTitle,
      staffId: staff?.id,
      print,
    });
  };

  return {
    savePrintAttempt,
  };
};
